import { render, staticRenderFns } from "./BuyerCallLogs.vue?vue&type=template&id=bd75392e&scoped=true"
import script from "./BuyerCallLogs.vue?vue&type=script&lang=js"
export * from "./BuyerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd75392e",
  null
  
)

export default component.exports